import React from 'react';

const MetricsDisplay = ({ metrics }) => {
  // Find the composite score
  const compositeMetric = metrics.find(metric => metric.Metric === 'Composite Score');
  const compositeScore = compositeMetric ? compositeMetric.Score : 0;

  // Format score for display
  const formatScore = (score) => {
    return (score * 100).toFixed(1) + '%';
  };

  // Get color based on score
  const getScoreColor = (score) => {
    if (score >= 0.8) return 'text-green-600';
    if (score >= 0.6) return 'text-primaryDark';
    if (score >= 0.4) return 'text-amber-600';
    return 'text-red-600';
  };

  // Get background color based on score
  const getScoreBackgroundColor = (score) => {
    if (score >= 0.8) return 'bg-green-100';
    if (score >= 0.6) return 'bg-blue-100';
    if (score >= 0.4) return 'bg-amber-100';
    return 'bg-red-100';
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
        <div>
          <h2 className="text-xl font-medium text-primary mb-1">Model Analysis Results</h2>
          <p className="text-gray-600 text-sm">Overall performance metrics for guardrail evaluation</p>
        </div>

        <div className="mt-4 md:mt-0 bg-gray-50 p-4 rounded-lg border border-gray-200">
          <div className="text-sm text-gray-500 font-medium">Overall Score</div>
          <div className={`text-3xl font-bold ${getScoreColor(compositeScore)}`}>
            {formatScore(compositeScore)}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {metrics
          .filter(metric => ['Mean', 'Good Enough Rate', 'Catastrophic Error Rate', 'Exact Match Rate'].includes(metric.Metric))
          .map((metric, index) => (
            <div key={index} className="bg-gray-50 p-4 rounded-lg border border-gray-200">
              <div className="text-sm text-gray-500 font-medium">{metric.Metric}</div>
              <div className={`text-2xl font-semibold ${getScoreColor(metric.Score)}`}>
                {formatScore(metric.Score)}
              </div>
              <div className="text-xs text-gray-500 mt-1">{metric.Description}</div>
            </div>
          ))}
      </div>

      {/* Simple bar chart visualization */}
      {/* <div className="mt-6">
        <h3 className="text-lg font-medium text-gray-800 mb-3">Metrics Visualization</h3>
        <div className="space-y-3">
          {metrics
            .filter(metric => metric.Metric !== 'Composite Score') // Exclude composite score
            .map((metric, index) => (
              <div key={index} className="bg-gray-50 p-3 rounded-lg">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm font-medium text-gray-700">{metric.Metric}</span>
                  <span className={`text-sm font-medium ${getScoreColor(metric.Score)}`}>
                    {formatScore(metric.Score)}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div 
                    className={`h-2.5 rounded-full ${getScoreBackgroundColor(metric.Score)}`} 
                    style={{ width: `${metric.Score * 100}%` }}
                  ></div>
                </div>
                <div className="text-xs text-gray-500 mt-1">{metric.Description}</div>
              </div>
            ))}
        </div>
      </div> */}

      <div className="mt-6">
        <h3 className="text-lg font-medium text-gray-800 mb-3">Metrics Visualization</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {metrics
            .filter(metric => metric.Metric !== 'Composite Score' &&
              !['Mean', 'Good Enough Rate', 'Catastrophic Error Rate', 'Exact Match Rate'].includes(metric.Metric))
            .map((metric, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <div className="text-sm text-gray-500 font-medium">{metric.Metric}</div>
                <div className={`text-2xl font-semibold ${getScoreColor(metric.Score)}`}>
                  {formatScore(metric.Score)}
                </div>
                <div className="text-xs text-gray-500 mt-1">{metric.Description}</div>
              </div>
            ))}
        </div>
      </div>


      <div className="mt-6">
        <h3 className="text-lg font-medium text-gray-800 mb-3">Metrics Explanation</h3>
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Metric</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Score</th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {metrics.map((metric, index) => (
                <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-3 text-sm font-medium text-gray-900">{metric.Metric}</td>
                  <td className="px-4 py-3 text-sm text-gray-900">{formatScore(metric.Score)}</td>
                  <td className="px-4 py-3 text-sm text-gray-500">{metric.Description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MetricsDisplay;